
import ContactAPIService from '@/modules/contacts/services/apiService'

import ReportView  from '@/modules/reporting/views/report.vue'

export default class ContactModule {
  constructor() {
  }

  install(Vue) {
    // Services
    Vue.prototype.$apiService.contactService = new ContactAPIService(Vue.prototype.$api, Vue.prototype.$reportingApi)
  }

  getRoutes() {
    return [
      {
        path: '/contacts',
        name: 'Contacts',
        component: () => import('@/modules/contacts/views/contactsList.vue'),
        meta: {
          requiresAuth: true,
          title: 'Contacts',
          menuLink: '/contacts',
          breadcrumbs: [
              { title: 'Home', link: '/'},
          ],
        }
      },
      {
        path: '/contacts/archived',
        name: 'Archived Contacts',
        component: () => import('@/modules/contacts/views/contactsList.vue'),
        props: {
          filterType: 'archived'
        },
        meta: {
          requiresAuth: true,
          title: 'Archived Contacts',
          menuLink: '/contacts/archived',
          breadcrumbs: [
              { title: 'Home', link: '/'}
          ],
        }
      },
      {
        path: '/contacts/archived/:id',
        name: 'Archived Contact',
        component: () => import('@/modules/contacts/views/contact.vue'),
        meta: {
          requiresAuth: true,
          title: 'Archived Contact',
          menuLink: '/contacts/archived',
          breadcrumbs: [
              { title: 'Home', link: '/'},
              { title: 'Archived Contacts', link: '/contacts/archived' }
          ],
        }
      },
      {
        path: '/contacts/new',
        name: 'new-contact',
        component: () => import('@/modules/contacts/views/contactNew.vue'),
        props: true,
        meta: {
          requiresAuth: true,
          title: 'New Contact',
          menuLink: '/contacts',
          breadcrumbs: [
              { title: 'Home', link: '/'},
              { title: 'Contacts', link: '/contacts' }
          ],
        }
      },
      {
        path: '/contacts/:id',
        name: 'Contact',
        component: () => import('@/modules/contacts/views/contact.vue'),
        meta: {
          requiresAuth: true,
          title: 'Contact',
          menuLink: '/contacts',
          breadcrumbs: [
              { title: 'Home', link: '/'},
              { title: 'Contacts', link: '/contacts' }
          ],
        }
      },
      {
        path: '/contacts/:id/supplier/pricing/report',
        name: 'ContactSupplierPricingReport',
        // JB: Not lazy-loaded to avoid flicker with layout issue
        component: ReportView,
        meta: {
          requiresAuth: true,
          title: 'Supplier Pricing Report',
          layout: 'Blank',
          report: {
            url: '/reporting/supplier/:id/pricing/report',
            variables: ['id']
          },
        }
      },
      {
        path: '/contacts/:id/customer/pricelist/:priceListId/report',
        name: 'ContactCustomerPricingReport',
        // JB: Not lazy-loaded to avoid flicker with layout issue
        component: ReportView,
        meta: {
          requiresAuth: true,
          title: 'Customer Pricing Report',
          layout: 'Blank',
          report: {
            url: '/reporting/customer/:id/pricelist/:priceListId/report',
            variables: ['id', 'priceListId']
          },
        }
      }
    ]
  }
}